import React, { memo } from "react"
import styled from "styled-components"

import { PlainLink, Paragraph, Link as ReactLink } from "components/text"
import { RelativeBox } from "components/box"
import Grid, { Col } from "components/grid"
import Icon from "components/icon"

import SubscribeFrom from "./components/subscribe-form"
import AdditionalLinks from "./components/additional-links"

import { baseRoutes } from "routes"

const FooterContainer = styled(RelativeBox).attrs({
  pt: 9,
  pb: 7
})`
  z-index: ${props => props.theme.layers.default};
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.evergreen};
`

const Link = styled(PlainLink)`
  font-family: ${props => props.theme.fonts.paragraph};
  text-decoration: none;
`

const linksLeft = [
  { text: "Our offering", to: baseRoutes.ourOffering() },
  { text: "Cove 101", to: baseRoutes.cove101() },
  { text: "Blog", to: baseRoutes.blog() },
  { text: "Reviews", to: baseRoutes.reviews() }
]
const linksRight = [
  { text: "FAQ", href: "https://support.withcove.com" },
  { text: "Contact", to: baseRoutes.contact() },
  { text: "Press", to: baseRoutes.press() },
  { text: "Careers", to: baseRoutes.careers() }
]

const Footer = () => (
  <FooterContainer>
    <Grid>
      <Col cols={[12]} mb={6}>
        <Icon name="coveChairTransparent" />
      </Col>
    </Grid>
    <Grid>
      <Col cols={[2, 1, 2, 2]}>
        {linksLeft.map(({ text, to }) => (
          <Paragraph key={text + to} mb={5} bold>
            <ReactLink to={to}>{text}</ReactLink>
          </Paragraph>
        ))}
      </Col>
      <Col cols={[2, 1, 2, 2]}>
        {linksRight.map(({ text, href, to }) => (
          <Paragraph key={text + href} mb={5} bold>
            {href ? (
              <Link href={href} underline={false}>
                {text}
              </Link>
            ) : (
              <ReactLink to={to}>{text}</ReactLink>
            )}
          </Paragraph>
        ))}
      </Col>
      <Col cols={[4, 4, 6, 5]} push={[0, 0, 2, 3]} color="paleAqua" mb={6} order={[-1, -1, "unset"]}>
        <SubscribeFrom />
      </Col>
    </Grid>
    <AdditionalLinks />
  </FooterContainer>
)

export default memo(Footer)
